export interface TopicAwareness {
  introducedByCurrentUser: boolean;
  introducedByAnyone: boolean;
  reminderCount: number;
  lastUpdatedAt?: string;
  needsUpdate: boolean;
}

// userId-keyed; matches the backend TopicAwarenessMap response shape
export type TopicAwarenessMap = Map<string, TopicAwareness>;

/**
 * Result of an awareness check.
 *
 * `awareness` is keyed by server userId. `resolvedIds` maps each checked
 * contact's normalized phone number to the server userId it resolved to (via
 * OPRF + tail lookup). Callers use `resolvedIds` to cache the userId back onto
 * their contact records (snowballId) so subsequent awareness lookups — which
 * key off the contact's cached id — actually match, even when the original
 * intro was sent by an unauthenticated user.
 */
export interface TopicAwarenessResult {
  awareness: TopicAwarenessMap;
  resolvedIds: Map<string, string>;
}

export const TopicAwarenessLogic = {
  merge(a: TopicAwareness, b: TopicAwareness): TopicAwareness {
    return {
      introducedByCurrentUser:
        a.introducedByCurrentUser || b.introducedByCurrentUser,
      introducedByAnyone: a.introducedByAnyone || b.introducedByAnyone,
      reminderCount: Math.max(a.reminderCount, b.reminderCount),
      lastUpdatedAt: a.lastUpdatedAt ?? b.lastUpdatedAt,
      needsUpdate: a.needsUpdate || b.needsUpdate,
    };
  },
};
